import React, { useState } from "react"
import { initialInputData } from "../../util/init";
import { convertyyyymmddToKebab } from "../../util/date";
import { insertColon } from "../../util/date";
import { shncodToRcodex } from "../../util/mapper";
import { removeFrontZero } from "../../util/util";
import ColumnHeader from "./ColumnHeader";
import Cell from "./Cell";

const RowTable = ({columnListData, setInputData, resbody, stagingStatus, setStagingStatus, setSelectedData}) => {
  const [columnList, setColumnList] = useState(columnListData);

  const onClickColumn = (index, listData) => {
    if (stagingStatus === index) {
      setSelectedData(null)
      setStagingStatus(null);
      setInputData(initialInputData);
      return;
    }
    setSelectedData(listData);
    setStagingStatus(index);
    setInputData(listData);
  }

  return (
    <div className="overflow-y-auto flex-col bg-white min-h-64 max-h-64 pb-2 border-b border-gray-400 flex-grow">
      <div className="flex sticky top-0">
        {columnList.map((columnName, index) => {
          return <ColumnHeader columnName={columnName} key={index}/>
        })}
      </div>
      <div>
        { 
          resbody && 
          (resbody.resultData.map((listData, index) => {
            return <Column stagingStatus={stagingStatus} listData={listData} index={index} key={index} onClickColumn={onClickColumn}/>
          }))
        }
      </div>
    </div>
  )
}

export default RowTable;

const Column = ({listData, stagingStatus, onClickColumn, index}) => {
  // column 클릭시, 보더 강화, 색상 진하게.
  // 다시 클릭 시, 위 효과 사라짐
  
  // 다른 column 클릭 시, 원래 클릭 한 column 효과 사라지고, 현재 column에 효과 적용.
  return (
    <div 
      onClick={() => onClickColumn(index, listData)} 
      className= {`${stagingStatus === index ? "border-t-2 border-b-2 border-black bg-blue-400" : "bg-white hover:bg-blue-200"} flex min-w-fit text-center font-semibold`} 
    >
      <Cell data={convertyyyymmddToKebab(listData.PPDATE).toString()}/>
      <Cell data={insertColon(listData.PPTIME)}/>
      <Cell data={shncodToRcodex[listData.PKCDXX]}/>
      <Cell data={removeFrontZero(listData.BSSWGH)}/>
      <Cell data={listData.HOGIXX}/>
      <Cell data={listData.SPEEDX}/>
      <Cell data={listData.SBSSWG}/>
      <Cell data={listData.WATERX}/>
      <Cell data={listData.THICKX}/>
      <Cell data={listData.MILDOX}/>
      <Cell data={listData.MDABGA}/>
      <Cell data={listData.CDABGA}/>
      <Cell data={listData.CDINDX}/>
      <Cell data={listData.MDCDXX}/>
      <Cell data={listData.PAGANG}/>
      <Cell data={listData.PAINDX}/>
      <Cell data={listData.COLORL}/>
      <Cell data={listData.COLORA}/>
      <Cell data={listData.COLORB}/>
      <Cell data={listData.COBBSI}/>
      <Cell data={listData.COBBTE}/>
      <Cell data={listData.COBBDE}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
      <Cell data={''}/>
    </div>
  )
}